<template>
    <div class="el-main-content el-main-content--full-height">
        <div
            class="el-grid-card el-grid-card--no-style calendar-main-wrapper route-planner-cal-wrapper"
        >
            <div class="el-row el-grid-card__filter-section">
                <div class="el-grid-card__filter-section-left">
                    <v-btn-toggle class="btn-calendar-group">
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-sm"
                            @click="prevDate"
                        >
                            <v-icon dark>keyboard_arrow_left</v-icon>
                        </v-btn>
                    </v-btn-toggle>
                    <el-date-picker
                        class="top-calendar-picker"
                        v-model="date"
                        format="yyyy-MM-dd (dddd)"
                        type="date"
                        :picker-options="pickerOptions"
                        :placeholder="$t('form.label.pickADay')"
                    >
                    </el-date-picker>
                    <v-btn-toggle
                        v-model="activeButton"
                        class="btn-calendar-group"
                    >
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-sm"
                            @click="nextDate"
                        >
                            <v-icon dark>keyboard_arrow_right</v-icon>
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-auto"
                            @click="today"
                        >
                            {{ $t('button.text.today') }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-auto"
                            @click="tomorrow"
                        >
                            {{ $t('button.text.tomorrow') }}
                        </v-btn>
                    </v-btn-toggle>
                </div>

                <div
                    class="el-grid-card__filter-section-center"
                    style="width: 30%"
                ></div>

                <div
                    class="el-grid-card__filter-section-right"
                    style="margin-left: 20px; margin-top: -40px"
                >
                    <el-checkbox
                        v-model="includeSubContainers"
                        @change="changeIncludeSubContainers"
                        :label="$t('table.column.includeSubContainers')"
                    ></el-checkbox>

                    <div
                        class="el-grid-card__filter-section-right"
                        style="table-layout: fixed"
                    >
                        <treeselect
                            v-model="selectedContainers"
                            value-format="object"
                            class="top-multiselect"
                            :multiple="true"
                            :flat="isFlat"
                            :value-consists-of="treeValueConsistsOf"
                            :limit="treeLimit"
                            :before-clear-all="handleBeforeClearAll"
                            :placeholder="$t('form.label.selectContainers')"
                            :options="selectedContainerTree"
                            :normalizer="normalizer"
                            style="padding-bottom: 10px"
                        ></treeselect>
                    </div>

                    <div class="el-row">
                        <v-btn
                            round
                            v-if="isApplyBtnVisible"
                            color="blue"
                            dark
                            @click="onApply"
                        >
                            {{ $t('button.text.search') }}
                        </v-btn>
                        <v-btn
                            v-if="isFilterBtnVisible"
                            style="margin-left: 10px"
                            round
                            :class="filterSearchBtnCls"
                            dark
                            @click="openFilterMenu"
                        >
                            {{ $t('form.label.filter') }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <el-row v-if="isContainersDataLoading">
                <v-progress-linear
                    :height="2"
                    color="primary"
                    indeterminate
                ></v-progress-linear>
            </el-row>
            <div class="el-row">
                <full-calendar
                    ref="calendar"
                    :config="config"
                    defaultView="agendaDay"
                    :header="header"
                    :events="bookings"
                    @event-selected="clickBooking"
                    @event-render="renderBooking"
                />
            </div>
            <button
                class="hidden"
                ref="btnDialog"
                @click.stop="dialog = true"
            ></button>
            <v-dialog
                v-model="dialog"
                transition="dialog-bottom-transition"
                :overlay="false"
                scrollable
                fullscreen
            >
                <v-card>
                    <v-toolbar
                        style="flex: 0 0 auto"
                        dark
                        class="primary el-dark-top-bar"
                    >
                        <v-btn icon @click.native.stop="closeDialog" dark>
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{
                            $t('title.details')
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <div class="el-panel-wrapper">
                        <div class="el-main-content">
                            <div class="el-grid-card">
                                <div>
                                    <div class="el-row">
                                        <el-col :span="18">
                                            <div class="el-row mb-2">
                                                <h2
                                                    class="el-table__inner-title"
                                                >
                                                    {{
                                                        form.unloadingArea
                                                            .Description || ''
                                                    }}
                                                    :
                                                    <span
                                                        class="el-table__inner-title--sub"
                                                    >
                                                        {{
                                                            form.start
                                                                ? form.start.format(
                                                                      'HH:mm'
                                                                  )
                                                                : ''
                                                        }}
                                                        -
                                                        {{
                                                            form.end
                                                                ? form.end.format(
                                                                      'HH:mm'
                                                                  )
                                                                : ''
                                                        }}
                                                    </span>
                                                </h2>
                                            </div>
                                        </el-col>
                                    </div>
                                    <div class="el-row flex">
                                        <div class="el-top-input-wrapper mr-5">
                                            <p
                                                style="
                                                    font-size: 16px;
                                                    color: #34c8b4;
                                                    font-weight: bold;
                                                "
                                            >
                                                {{
                                                    $t('table.label.recipient')
                                                }}:
                                            </p>
                                            <p
                                                style="
                                                    font-size: 14px;
                                                    color: #fff;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        'table.column.recipientCompany'
                                                    )
                                                }}
                                                : {{ form.recipientCompany }}
                                            </p>
                                            <p
                                                style="
                                                    font-size: 14px;
                                                    color: #fff;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        'table.column.recipientName'
                                                    )
                                                }}
                                                : {{ form.recipientName }}
                                            </p>
                                            <p
                                                style="
                                                    font-size: 14px;
                                                    color: #fff;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        'form.label.recipientPhone'
                                                    )
                                                }}
                                                : {{ form.recipientPhone }}
                                            </p>
                                        </div>

                                        <div
                                            class="el-top-input-wrapper mr-4"
                                            v-if="form.RouteReference"
                                        >
                                            <p
                                                style="
                                                    font-size: 16px;
                                                    color: #34c8b4;
                                                    font-weight: bold;
                                                "
                                            >
                                                {{ $t('form.label.route') }}:
                                            </p>
                                            <p
                                                style="
                                                    font-size: 14px;
                                                    color: #fff;
                                                "
                                            >
                                                {{ form.RouteReference }}
                                            </p>
                                        </div>

                                        <div class="el-top-input-wrapper mr-4">
                                            <p
                                                style="
                                                    font-size: 16px;
                                                    color: #34c8b4;
                                                    font-weight: bold;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        'form.label.unloadingArea'
                                                    )
                                                }}:
                                            </p>
                                            <p
                                                style="
                                                    font-size: 14px;
                                                    color: #fff;
                                                "
                                            >
                                                {{
                                                    form.unloadingArea
                                                        .ShortDescription
                                                }}
                                            </p>
                                        </div>
                                        <div class="el-top-input-wrapper mr-4">
                                            <p
                                                style="
                                                    font-size: 16px;
                                                    color: #34c8b4;
                                                    font-weight: bold;
                                                "
                                            >
                                                {{ $t('table.label.vehicle') }}:
                                            </p>
                                            <p
                                                style="
                                                    font-size: 14px;
                                                    color: #fff;
                                                "
                                            >
                                                {{ form.vehicle }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="el-row">
                                        <div
                                            class="el-collapse-item__header-icon-list el-top-icon-wrapper"
                                        >
                                            <ul class="resources-icon-list">
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'FORKLIFT'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__transporter"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'TRUCK'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__truck"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'MANPOWER'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__team"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'CRANE'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__crane"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'TOOLS'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__tools"
                                                ></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <draggable
                                        v-if="editing"
                                        :list="packageGroups"
                                        :options="{ group: 'packages' }"
                                    >
                                        <div
                                            class="el-row"
                                            :key="packageGroup.PackageGroupID"
                                            v-for="packageGroup in packageGroupsWithoutHiddenItems"
                                        >
                                            <div
                                                class="el-package-group-wrapper"
                                            >
                                                <div class="el-row">
                                                    <div class="el-table-info">
                                                        <div
                                                            class="el-table-info__panel"
                                                        >
                                                            <ul>
                                                                <li>
                                                                    {{
                                                                        $t(
                                                                            'table.data.label.ref'
                                                                        )
                                                                    }}
                                                                    <span
                                                                        v-text="
                                                                            packageGroup.Reference
                                                                        "
                                                                    ></span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div
                                                            class="el-table-info__actions"
                                                        ></div>
                                                    </div>
                                                    <el-table
                                                        :data="
                                                            packageGroup.PackageItems
                                                        "
                                                        class="el-table__inner-editable el-table__inner-editable--no-top-margin readonly"
                                                        style="width: 100%"
                                                        border
                                                        :cell-style="
                                                            changeColumnBgColor
                                                        "
                                                    >
                                                        <el-table-column
                                                            prop="StatusDescription"
                                                            :label="
                                                                $t(
                                                                    'table.column.status'
                                                                )
                                                            "
                                                        >
                                                        </el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.description'
                                                                )
                                                            "
                                                            prop="Description"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.packageType'
                                                                )
                                                            "
                                                            prop="PackageType"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.trackingReference'
                                                                )
                                                            "
                                                            prop="TrackingReference"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.customerReference'
                                                                )
                                                            "
                                                            prop="CustomReference"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.height'
                                                                )
                                                            "
                                                            prop="Height"
                                                            width="100"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.width'
                                                                )
                                                            "
                                                            prop="Width"
                                                            width="100"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.length'
                                                                )
                                                            "
                                                            prop="Length"
                                                            width="100"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.weight'
                                                                )
                                                            "
                                                            prop="Weight"
                                                            width="100"
                                                        ></el-table-column>
                                                    </el-table>
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-dialog>
        </div>

        <!-- Container Search Criteria Filter Slide Collapse -->
        <Slide
            right
            :isOpen="searchCriteriaOpenState"
            :burgerIcon="false"
            @closeMenu="searchCriteriaOpenState = false"
            @click="searchFilterComponentClick"
            width="420"
        >
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style="
                    padding-top: 0;
                    padding-bottom: 0;
                    margin-bottom: 10px;
                    margin-top: 0;
                "
            >
                <h4 class="search-filter-header">
                    {{ $t('form.label.filter') }}
                </h4>
            </div>
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style="
                    padding-bottom: 0 !important;
                    padding-top: 0 !important;
                    margin-top: 10px;
                "
            >
                <v-select
                    :items="allUnloadingAreasOfSelectedContainers"
                    item-text="title"
                    :label="$t('title.unloadingAreas')"
                    @input="filterSearchChange('unloadingAreaChange')"
                    v-model="unloadingAreasSearchFilter"
                    multiple
                    clearable
                    style="margin-bottom: -10px !important"
                ></v-select>
            </div>
            <div @click="searchFilterComponentClick" style="margin-top: -30px">
                <v-checkbox
                    color="orange"
                    hide-details
                    style="font-size: 8px"
                    v-model="toggleSelectAllCheckbox"
                    :label="$t('form.label.selectAll')"
                ></v-checkbox>
            </div>

            <div @click="searchFilterComponentClick" style="margin-top: 5px">
                <v-checkbox
                    hide-details
                    v-model="showSlotBookings"
                    :label="$t('form.label.showSlotBookings')"
                >
                </v-checkbox>
            </div>
            <div @click="searchFilterComponentClick" style="margin-top: -25px">
                <v-checkbox
                    hide-details
                    v-model="showMilkRunBookings"
                    :label="$t('form.label.showMilkRunBookings')"
                >
                </v-checkbox>
            </div>
            <div @click="searchFilterComponentClick" style="margin-top: -25px">
                <v-checkbox
                    hide-details
                    v-model="showPassBookings"
                    :label="$t('form.label.showPassBookings')"
                >
                </v-checkbox>
            </div>
            <div @click="searchFilterComponentClick" style="margin-top: 0px">
                <v-radio-group v-model="showAllUnloadingAreas">
                    <v-radio
                        key="SHOW_ALL"
                        :label="$t('form.label.showAllUnloadingAreas')"
                        value="SHOW_ALL"
                    ></v-radio>
                    <v-radio
                        key="SHOW_WITH_DATA"
                        :label="$t('form.label.showUnloadingAreasWithData')"
                        value="SHOW_WITH_DATA"
                    ></v-radio>
                    <v-radio
                        key="SHOW_WITH_OUT_DATA"
                        :label="$t('form.label.showUnloadingAreasWithoutData')"
                        value="SHOW_WITH_OUT_DATA"
                    ></v-radio>
                </v-radio-group>
            </div>
        </Slide>
    </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import FullCalendar from '../../Calender'
import Treeselect from '@riophae/vue-treeselect'
import BookingOverviewMilkrunEventComponent from './BookingOverviewMilkrunEvent'
import MaterialManagerList from '../material-manager/MaterialManagerList'
import StcDialog from '../../Dialog'
import { Slide } from 'vue-burger-menu'

let BookingOverviewMilkrunEvent = Vue.extend(
    BookingOverviewMilkrunEventComponent
)

export default {
    name: 'booking-overview',

    data() {
        let today = DateTime.local().toJSDate()
        let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

        return {
            dateTimeFormat,
            activeButton: 1,
            filterByContainer: true,
            date: today,
            dialog: false,
            dropped: false,
            editing: false,
            saving: false,
            showSlotBookings: true,
            showMilkRunBookings: true,
            editSlotBookings: false,
            collapseMaterialManager: false,
            collapseRouteManager: false,
            routes: [],
            dataMaterials: [],
            driversData: [],
            vehiclesData: [],
            bookingsData: [],
            gatesData: [],
            containers: [],
            packageGroups: [],
            recipientData: [],
            selectedContainers: [],
            originalPackageGroups: [],
            allUnloadingAreas: [],
            ContainerID: '',
            header: {
                left: '',
                center: '',
                right: '',
            },
            actor: {
                ActorID: '',
                AccessSets: [],
            },
            route: {
                BLCRouteID: '',
                Reference: '',
                VehicleID: '',
            },
            form: {
                start: '',
                end: '',
                route: '',
                gates: [],
                inGate: '',
                outGate: '',
                vehicle: '',
                pinCode: '',
                PlateNo: '',
                recipient: '',
                schedule: {
                    Description: '',
                    ScheduleParts: [
                        {
                            ValidFrom: null,
                            ValidTo: null,
                            WeekStart: 0,
                            WeekStop: 0,
                            IsSimpleSchedule: true,
                        },
                    ],
                },
                dateTimeRange: '',
                unloadingArea: '',
                recipientName: '',
                recipientPhone: '',
                recipientCompany: '',
                requestedResources: [],
                unloadingAreas: [],
            },
            routeForm: {
                driver: '',
                vehicle: '',
            },
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            materialManagerListComponent: '',
            materialDialog: false,
            blcNotification: undefined,
            columnHeadersSelectedUnloadedAreas: [],
            columnHeadersAllUnloadedAreas: [],
            columnHeaders: [],
            containersWithData: [],
            allUnloadingAreasOfSelectedContainers: [],
            unloadingAreasWithData: [],
            showAllUnloadingAreas: 'SHOW_WITH_DATA',
            searchCriteriaOpenState: false,
            filterSearchBtnCls: 'filter-search-btn-color',
            isFlat: true,
            includeSubContainers: false,
            treeLimit: 5,
            treeValueConsistsOf: 'ALL',
            containerTreeBookingOverview: [],
            isContainersDataLoading: false,
            containerSearchFilter: '',
            unloadingAreasSearchFilter: '',
            isApplyBtnVisible: true,
            isFilterBtnVisible: false,
            showPassBookings: true,
            originalColumnHeaderArr: [],
            toggleSelectAllCheckbox: false,
        }
    },

    async created() {
        await Promise.all([
            this.fetchAllContainers(),
            this.fetchAllUnloadingAreas(),
        ])
    },

    mixins: [],

    components: {
        'full-calendar': FullCalendar,
        draggable: draggable,
        treeselect: Treeselect,
        'stc-dialog': StcDialog,
        'stc-material-manager-list': MaterialManagerList,
        Slide,
    },

    watch: {
        toggleSelectAllCheckbox(val) {
            if (val) {
                this.showAllUnloadingAreas = 'SHOW_ALL'
            } else {
                this.showAllUnloadingAreas = 'SHOW_WITH_DATA'
            }
        },

        showAllUnloadingAreas(selectedVal) {
            if (selectedVal === 'SHOW_ALL') {
                this.columnHeaders = this.columnHeadersAllUnloadedAreas
            } else if (selectedVal === 'SHOW_WITH_DATA') {
                this.columnHeaders = this.columnHeadersSelectedUnloadedAreas
            } else if (selectedVal === 'SHOW_WITH_OUT_DATA') {
                this.columnHeaders = _.differenceBy(
                    this.columnHeadersAllUnloadedAreas,
                    this.columnHeadersSelectedUnloadedAreas,
                    'id'
                )
            }
            this.unloadingAreasSearchFilter = this.columnHeaders
            this.$refs.calendar.fireMethod('refetchResources')
        },
        selectedContainer: function () {
            this.fetchRoutes()
            this.fetchDrivers()
            this.fetchVehicles()
            this.fetchMaterials()
        },

        route: function () {
            this.$refs.calendar.$emit('rerender-events')
        },

        selectedContainers: async function () {
            this.isApplyBtnVisible =
                this.selectedContainers && this.selectedContainers.length > 0
            this.$refs.calendar.fireMethod('refetchResources')

            // Show all unloading areas for selected containers (NEW REQUIREMENT)

            if (this.selectedContainers) {
                let unloadingAreasColumnHeader3 = []

                this.selectedContainers.forEach((container) => {
                    this.allUnloadingAreas.forEach((area) => {
                        if (container.ContainerID === area.ContainerID) {
                            area.ContainerDescription = container.Description
                            unloadingAreasColumnHeader3.push(area)
                        }
                    })
                })

                unloadingAreasColumnHeader3 = unloadingAreasColumnHeader3
                    .filter((area) => area.IsActive)
                    .map((area) => {
                        return {
                            id: area.UnloadingAreaID,
                            title:
                                area.ShortDescription +
                                ' - ' +
                                area.ContainerDescription,
                            ...area,
                        }
                    })

                // Remove duplicate titles
                unloadingAreasColumnHeader3 = unloadingAreasColumnHeader3.filter(
                    (x, index, self) =>
                        index ===
                        self.findIndex(
                            (t) => t.ShortDescription === x.ShortDescription
                        )
                )
                this.allUnloadingAreasOfSelectedContainers = unloadingAreasColumnHeader3
            }
        },

        date: async function () {
            this.route = {
                BLCRouteID: '',
                Reference: '',
            }

            if (this.selectedContainers && this.selectedContainers.length > 0) {
                await this.fetchBookings()
                this.$refs.calendar.fireMethod('gotoDate', this.date)
            }
        },
    },

    computed: {
        ...mapGetters(['containerTree', 'selectedContainer']),

        selectedContainerTree() {
            //  This will populate the container tree. Check normalizer. It will pick this container and search for children and show it accordingly
            return [this.selectedContainer]
        },

        materials() {
            return this.dataMaterials.map((notification) => {
                return {
                    ...notification,
                    PackageGroups: notification.PackageGroups.filter(
                        (group) => {
                            return group.PackageItems.some(
                                (item) =>
                                    item.StatusDescription !==
                                    'HIDDEN_INVENTORY_TO_STOCK'
                            )
                        }
                    ).map((group) => {
                        return {
                            BLCNotificationID: notification.BLCNotificationID,
                            RequestedResources: notification.RequestedResouces,
                            ...group,
                        }
                    }),
                }
            })
        },

        orderedMaterials() {
            return this.materials.map((material) => {
                return {
                    ...material,
                    ActualArrivalDate: DateTime.fromISO(
                        material.ActualArrival
                    ).toFormat('yyyy-MM-dd'),
                }
            })
        },

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        actorPayload() {
            let form = _.cloneDeep(this.form)

            form.gates = this.gates

            form.requestedResources = _.uniq(this.requestedResources)

            let accessSets = this.buildAccessSet(form, 'MILKRUN')

            return {
                ActorType: 'MILKRUN',
                MAIsEnabled: true,
                PinCode: form.pinCode,
                LocationValidationDisabled: true,
                AccessSets: accessSets,
            }
        },

        routePayload() {
            let date = DateTime.fromISO(this.date.toISOString()).toFormat(
                this.dateTimeFormat
            )

            return {
                BLCContainerID: this.selectedContainer.ContainerID,
                DriverUserID: this.routeForm.driver.UserID,
                VehicleID: this.routeForm.vehicle.VehicleID,
                RouteDate: date,
            }
        },

        gates() {
            let gates = this.gatesData.filter((gate) => {
                return gate.DirectionInEnabled || gate.DirectionOutEnabled
            })

            return _.sortBy(gates, 'Name')
        },

        inGates() {
            let gates = _.cloneDeep(this.gates)

            return gates
                .filter((gate) => {
                    return gate.DirectionInEnabled
                })
                .map((gate) => {
                    gate.DirectionOutEnabled = false

                    return gate
                })
        },

        outGates() {
            let gates = _.cloneDeep(this.gates)

            return gates
                .filter((gate) => {
                    return gate.DirectionOutEnabled
                })
                .map((gate) => {
                    gate.DirectionInEnabled = false

                    return gate
                })
        },

        drivers() {
            return this.driversData.map((driver) => {
                return {
                    ...driver,
                    FullName: driver.FirstName + ' ' + driver.LastName,
                }
            })
        },

        vehicles() {
            return this.vehiclesData.map((vehicle) => {
                return {
                    ...vehicle,
                    FullDescription:
                        vehicle.Description + ' (' + vehicle.PlateNo + ')',
                }
            })
        },

        requestedResources() {
            return this.packageGroups
                .map((group) => {
                    return group.RequestedResources
                })
                .reduce((a, b) => a.concat(b), [])
        },

        recipients() {
            return this.recipientData.map((item) => {
                let company = item.Company ? ` (${item.Company})` : ''

                item['Label'] = `${item.FirstName} ${item.LastName}${company}`

                return item
            })
        },

        milkRuns() {
            let milkRuns = []

            for (let route of this.routes) {
                for (let actor of route.Actors) {
                    // sometimes actor is null, if null we don't proceed (backend issue)
                    if (!actor) continue

                    let accessSet = actor.AccessSets && actor.AccessSets[0]
                    let schedule =
                        accessSet &&
                        accessSet.Schedules &&
                        accessSet.Schedules[0]
                    let part =
                        schedule &&
                        schedule.ScheduleParts &&
                        schedule.ScheduleParts[0]

                    if (!accessSet || !schedule || !part) continue

                    let fromTime = DateTime.fromString(
                        part.ValidFrom,
                        this.dateTimeFormat
                    ).toISO()
                    let toTime = DateTime.fromString(
                        part.ValidTo,
                        this.dateTimeFormat
                    ).toISO()

                    milkRuns.push({
                        id: part.SchedulePartID,
                        actorId: actor.ActorID,
                        accessSetId: accessSet.AccessSetID,
                        isSimpleSchedule: part.IsSimpleSchedule,
                        direction: part.Direction,
                        scheduleId: schedule.ScheduleID,
                        routeId: route.BLCRouteID,
                        resourceId: accessSet.UnloadingAreaID,
                        destinationContainerID:
                            accessSet.DestinationContainerID,
                        title: route.Description,
                        actor: actor,
                        route: route,
                        start: fromTime,
                        end: toTime,
                        requestedResources: accessSet.RequestedResources,
                        isExpress: actor.IsExpress || false,
                    })
                }
            }

            return _.uniqBy(milkRuns, 'actorId')
        },

        bookings() {
            let allBookings = []

            for (let actor of this.bookingsData) {
                const accessSet = actor.AccessSets[0]
                const schedule = accessSet.Schedules[0]
                const part = schedule.ScheduleParts[0]

                if (!accessSet || !schedule || !part) continue

                let fromTime = DateTime.fromString(
                    part.ValidFrom,
                    this.dateTimeFormat
                ).toISO()
                let toTime = DateTime.fromString(
                    part.ValidTo,
                    this.dateTimeFormat
                ).toISO()

                if (actor.ActorType === 'PASS') {
                    actor.UnloadingAreaID = 'passId'
                    accessSet.UnloadingAreaID = 'passId'
                }

                allBookings.push({
                    id: part.SchedulePartID,
                    actorId: actor.ActorID,
                    isSimpleSchedule: part.IsSimpleSchedule,
                    direction: part.Direction,
                    accessSetId: accessSet.AccessSetID,
                    scheduleId: schedule.ScheduleID,
                    resourceId: accessSet.UnloadingAreaID,
                    destinationContainerID: accessSet.DestinationContainerID,
                    title: actor.BookingReference,
                    actor: actor,
                    start: fromTime,
                    end: toTime,
                    editable: this.editSlotBookings,
                    requestedResources: accessSet.RequestedResources,
                    isExpress: actor.IsExpress || false,
                })
            }
            // console.log(this.showSlotBookings, this.showMilkRunBookings)
            if (this.showSlotBookings && this.showMilkRunBookings) {
                // console.log(allBookings)
                return allBookings
            } else if (this.showSlotBookings && !this.showMilkRunBookings) {
                // console.log(2)
                let allBookingsWithoutSLOTs = []
                allBookings.forEach((x) => {
                    if (x.actor && x.actor.ActorType !== 'MILKRUN') {
                        allBookingsWithoutSLOTs.push(x)
                    }
                })
                return allBookingsWithoutSLOTs
            } else if (!this.showSlotBookings && this.showMilkRunBookings) {
                // console.log(3)
                let allBookingsWithoutSLOTs = []
                allBookings.forEach((x) => {
                    if (x.actor && x.actor.ActorType !== 'SLOT') {
                        allBookingsWithoutSLOTs.push(x)
                    }
                })
                return allBookingsWithoutSLOTs
            } else if (!this.showSlotBookings && !this.showMilkRunBookings) {
                // console.log(4)
                let allBookingsWithoutSLOTs = []
                allBookings.forEach((x) => {
                    if (
                        x.actor &&
                        x.actor.ActorType !== 'SLOT' &&
                        x.actor &&
                        x.actor.ActorType !== 'MILKRUN'
                    ) {
                        allBookingsWithoutSLOTs.push(x)
                    }
                })
                // console.log('4 ', allBookingsWithoutSLOTs)
                return allBookingsWithoutSLOTs
            }
            return allBookings
        },

        routeVehicle() {
            return this.vehicles.find((vehicle) => {
                return vehicle.VehicleID == this.route.VehicleID
            })
        },

        config() {
            let scrollTime = '06:00:00'

            return {
                scrollTime,
                slotLabelFormat: 'HH:mm',
                timezone: 'local',
                allDaySlot: false,
                eventOverlap: false,
                schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
                defaultView: 'agendaDay',
                // eventLimit: true, // for all non-TimeGrid views
                // https://github.com/fullcalendar/fullcalendar/issues/4218
                // views: {
                //     timeGrid: {
                //         eventLimit: 5 // adjust to 6 only for timeGridWeek/timeGridDay
                //     }
                // },
                resources: (callback) => {
                    callback(this.columnHeaders)
                },
                resourceRender(resource, element) {
                    element.attr('title', resource.title)
                },
            }
        },

        filteredMaterials() {
            if (this.filterByContainer) {
                return this.materials.filter(
                    (item) =>
                        item.DestinationContainerID ===
                        this.form.unloadingArea.ContainerID
                )
            }
            return this.materials
        },

        packageGroupsWithoutHiddenItems() {
            return this.packageGroups.map((item) => {
                return {
                    ...item,
                    PackageItems: item.PackageItems.filter((item) => {
                        return (
                            item.StatusDescription !==
                            'HIDDEN_INVENTORY_TO_STOCK'
                        )
                    }),
                }
            })
        },
    },

    methods: {
        checkPassBookings(val) {
            let isPassContaining = false
            for (let booking of this.bookingsData) {
                if (booking.ActorType === 'PASS') {
                    isPassContaining = true
                    break
                }
            }
            if (val && isPassContaining) {
                const passObj = {
                    id: 'passId',
                    resourceId: 'passId',
                    UnloadingAreaID: 'passId',
                    title: 'PASS',
                    IsActive: true,
                    ShortDescription: 'PASS',
                    Description: 'PASS',
                    ContainerDescription: 'PASS',
                    ContainerID: this.selectedContainer.ContainerID,
                }
                this.columnHeaders.push(passObj)
            } else {
                this.columnHeaders = _.reject(
                    this.columnHeaders,
                    function (el) {
                        return el.title === 'PASS'
                    }
                )
            }
        },

        checkMilkRunBookings(val) {
            console.debug(val)
        },

        async onApply() {
            this.showAllUnloadingAreas = 'SHOW_WITH_DATA'
            this.showSlotBookings = true
            this.showMilkRunBookings = true
            this.showPassBookings = true
            await this.fetchBookings()
            this.$refs.calendar.fireMethod('gotoDate', this.date)
        },

        filterSearchChange(event) {
            if (event === 'containerChange') {
                let dataArr = this.columnHeadersSelectedUnloadedAreas
                let filteredList = []
                this.containerSearchFilter.forEach((x) => {
                    dataArr.forEach((y) => {
                        if (y.ContainerID === x.ContainerID) {
                            filteredList.push(y)
                        }
                    })
                })
                if (filteredList) {
                    let element = filteredList.find(
                        (x) => x.UnloadingAreaID === 'passId'
                    )
                    if (element) {
                        filteredList.push(
                            filteredList.splice(
                                filteredList.indexOf(element),
                                1
                            )[0]
                        )
                    }
                }
                this.unloadingAreasSearchFilter = filteredList
                this.columnHeaders = filteredList
                this.$refs.calendar.fireMethod('refetchResources')
            } else {
                this.columnHeaders = this.unloadingAreasSearchFilter
                this.$refs.calendar.fireMethod('refetchResources')
            }
        },

        searchWithFilters() {
            this.fetchBookings()
            this.$refs.calendar.fireMethod('gotoDate', this.date)
            this.searchCriteriaOpenState = false
        },

        changeIncludeSubContainers() {
            if (this.includeSubContainers) {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = false
                    }.bind(this),
                    1000
                )
            } else {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = true
                    }.bind(this),
                    1000
                )
            }
        },

        searchFilterComponentClick(e) {
            if (
                !e.target.className ||
                e.target.className === 'el-checkbox__original' ||
                'el-checkbox' ||
                e.target.className === 'el-checkbox__label' ||
                e.target.className === 'layout row' ||
                e.target.className === 'layout' ||
                e.target.className === 'row' ||
                e.target.className === 'el-grid-card__filter-section-right' ||
                e.target.className === 'search-filter-reset' ||
                e.target.className === 'input-group__selections' ||
                e.target.className === 'input-group__details' ||
                e.target.className === 'input-group__input' ||
                e.target.className ===
                    'input-group input-group--dirty input-group--text-field primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--dirty input-group--append-icon input-group--text-field input-group--select input-group--multiple primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select input-group--multiple primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select input-group--multiple input-group--open primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--dirty input-group--append-icon input-group--text-field input-group--select input-group--multiple input-group--open primary--text' ||
                e.target.className ===
                    'input-group input-group--text-field primary--text' ||
                e.target.className === 'input-group__selections__comma' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select input-group--open primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--dirty input-group--append-icon input-group--text-field input-group--select primary--text'
            ) {
                e.stopPropagation()
            }
        },

        checkNodesRecursively(containerArr, checkingArr, finalArr) {
            let tempArr = []
            for (let c1 of checkingArr) {
                for (let c2 of containerArr) {
                    if (c2.ParentContainerID === c1.ContainerID) {
                        tempArr.push(c2)
                    }
                }
            }
            if (tempArr.length > 0) {
                finalArr.push(...tempArr)
                this.checkNodesRecursively(containerArr, tempArr, finalArr)
            } else {
                // Container request (No need of parent container of/and selected container)
                // this.selectedContainers = finalArr // This will fill up the container tree select

                // Populate container tree with parent nodes
                let idAttr = 'ContainerID'
                let parentAttr = 'ParentContainerID'
                let childrenAttr = 'Children'
                let tree = []
                let lookup = {}

                let containers = []
                let allContainers = this.containers

                allContainers.forEach((parentCon1) => {
                    if (
                        parentCon1.ContainerID ===
                        this.selectedContainer.ParentContainerID
                    ) {
                        containers.push(parentCon1)
                    }
                })

                containers.push(this.selectedContainer)
                containers.push(...finalArr)

                containers.forEach((obj) => {
                    lookup[obj[idAttr]] = obj
                    obj[childrenAttr] = []
                })

                containers.forEach((obj) => {
                    if (obj[parentAttr] != null && lookup[obj[parentAttr]]) {
                        lookup[obj[parentAttr]][childrenAttr].push(obj)
                    } else {
                        tree.push(obj)
                    }
                })

                this.containerTreeBookingOverview = tree

                return finalArr
            }
        },

        changeColumnBgColor(column) {
            if (column.columnIndex === 0) {
                switch (column.row.StatusDescription) {
                    case 'DELIVERY_CONFIRMED':
                        return 'background-color: #5ed225 !important'
                    case 'UNABLE_TO_DELIVER':
                        return 'background-color: #f72d2d !important'
                    default:
                        return ''
                }
            }
            return ''
        },

        clickBooking() {},

        renderBooking(booking, element) {
            if (!booking || !booking._id) {
                return false
            }
            this.hideCalendarPoppers()

            let instance = null

            instance = new BookingOverviewMilkrunEvent({
                propsData: {
                    booking,
                    element,
                    trans: this.$t,
                    containers: this.containers,
                    route: this.route,
                },
            })
            instance.$on('view-booking', (booking) =>
                this.selectBooking(booking)
            )
            instance.$mount()

            if (element.eq(0).find('.fc-content') && instance.$el) {
                this.$nextTick(() => {
                    element.eq(0).find('.fc-content').html(instance.$el)
                })
            }
        },

        hideCalendarPoppers() {
            for (const popper of document.querySelectorAll('.tippy-popper')) {
                const instance = popper._tippy

                if (instance && instance.state.visible) {
                    instance.popperInstance.disableEventListeners()
                    instance.hide()
                }
            }
        },

        async selectBooking(booking) {
            if (!this.dropped) this.$refs.btnDialog.click()
            this.editing = true

            let resource = _.find(
                this.$refs.calendar.fireMethod('getResources'),
                {
                    id: booking.resourceId,
                }
            )

            this.actor = booking.actor
            this.form.route = booking.route
            this.form.start = booking.start
            this.form.end = booking.end
            this.form.pinCode = booking.actor.PinCode
            this.form.PlateNo = booking.actor.PlateNo
            this.form.dateTimeRange = [booking.start, booking.end]
            this.form.unloadingArea = resource
            this.form.vehicle = booking.actor.VehicleDescription
            this.form.RouteReference = booking.actor.RouteReference

            this.packageGroups = booking.actor.PackageGroups || []
            this.originalPackageGroups = _.cloneDeep(
                booking.actor.PackageGroups
            )

            if (this.packageGroups.length) {
                Vue.set(
                    this.packageGroups[0],
                    'RequestedResources',
                    booking.requestedResources
                )
            }

            booking.actor.AccessSets.forEach((accessSet) => {
                this.fillFormAccessSet(accessSet)
            })
        },

        async generatePin() {
            let { data } = await this.$http.get('/Util/GeneratePin')

            return data
        },

        fillFormAccessSet(accessSet) {
            this.form.recipientName = accessSet.RecipientName
            accessSet.Schedules.forEach((schedule) => {
                schedule.ScheduleParts.forEach((part) => {
                    let direction = part.Direction.toLowerCase()

                    this.form[`${direction}Gate`] =
                        _.find(this[`${direction}Gates`], {
                            CheckpointID: accessSet['CheckPointID'],
                        }) || ''

                    this.form.recipient = accessSet.RecipientName
                    this.form.recipientName = accessSet.RecipientName
                    this.form.recipientCompany = accessSet.RecipientCompany
                    this.form.recipientPhone = accessSet.RecipientPhone
                    this.form.requestedResources = accessSet.RequestedResources
                })
            })
        },

        async fetchRoutes() {
            let container = this.selectedContainer

            if (!_.isEmpty(container) && this.date) {
                let date = DateTime.fromISO(this.date.toISOString()).toFormat(
                    this.dateTimeFormat
                )

                let { data } = await this.$http.get(
                    `/BLC/${container.ContainerID}/Route/Date/${date}`
                )

                this.routes = data
                return data
            }
        },

        async fetchBookings() {
            let containerIdList = [
                ...this.selectedContainers
                    .filter((container) => container.ContainerType !== 'CCC')
                    .map((container) => container.ContainerID),
            ]
            if (!containerIdList || containerIdList.length === 0) {
                return false
            }
            this.isContainersDataLoading = true
            this.isApplyBtnVisible = false

            let routeList = await this.fetchRoutes()

            let date = DateTime.fromISO(this.date.toISOString())
            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let dateTimeFrom = date.startOf('day').toFormat(dateTimeFormat)
            let dateTimeTo = date.endOf('day').toFormat(dateTimeFormat)

            let { data } = await this.$http.post(`Actor/Search`, {
                ValidFrom: dateTimeFrom,
                ValidTo: dateTimeTo,
                ActorTypeFilter: ['MILKRUN', 'SLOT', 'PASS'],
                IncludeOptionalItems: ['PACKAGE_GROUPS_ITEMS'],
                DestinationContainerFilter: containerIdList,
            })

            for (let booking of data) {
                if (booking.AccessSets && booking.AccessSets.length > 0) {
                    let color = ''
                    this.allUnloadingAreas.forEach((area) => {
                        if (
                            area.UnloadingAreaID ===
                            booking.AccessSets[0].UnloadingAreaID
                        ) {
                            color = area.Color
                        }
                    })
                    // TODOAAA

                    booking.ContainerID =
                        booking.AccessSets[0].DestinationContainerID
                    booking.UnloadingAreaID =
                        booking.AccessSets[0].UnloadingAreaID
                    booking.UnloadingArea = booking.AccessSets[0].UnloadingArea
                    booking.Color = color
                }
            }

            if (routeList) {
                data.forEach((booking) =>
                    routeList.forEach((route) => {
                        if (route && route.Actors) {
                            route.Actors.forEach((actor) => {
                                if (actor.ActorID === booking.ActorID) {
                                    booking.VehicleDescription =
                                        route.VehicleDescription
                                    booking.DriverUserFullName =
                                        route.DriverUserFullName
                                    booking.RouteReference = route.Reference
                                }
                            })
                        }
                    })
                )
            }

            this.bookingsData = data
            this.isContainersDataLoading = false
            this.isApplyBtnVisible = true
            this.isFilterBtnVisible = true
            this.populateCalendarColumnHeaders()
        },

        populateCalendarColumnHeaders() {
            let unloadingAreasColumnHeader = []
            let unloadingAreasColumnHeader2 = []
            let unloadingAreasColumnHeader3 = []

            // All areas in booking response data (booking.UnloadingAreaID === area.UnloadingAreaID)
            this.allUnloadingAreas.forEach((area) => {
                this.bookingsData.forEach((booking) => {
                    // UnloadingAreaID is unique. ShortDescription/Description is not unique
                    if (booking.UnloadingAreaID === area.UnloadingAreaID) {
                        this.selectedContainers.forEach((container) => {
                            if (container.ContainerID === booking.ContainerID) {
                                area.ContainerDescription =
                                    container.Description
                            }
                        })
                        unloadingAreasColumnHeader.push(area)
                    }
                })
            })

            // Show all unloading areas for selected containers (NEW REQUIREMENT)
            this.selectedContainers.forEach((container) => {
                this.allUnloadingAreas.forEach((area) => {
                    if (container.ContainerID === area.ContainerID) {
                        area.ContainerDescription = container.Description
                        unloadingAreasColumnHeader2.push(area)
                    }
                })
            })

            unloadingAreasColumnHeader = unloadingAreasColumnHeader
                .filter((area) => area.IsActive)
                .map((area) => {
                    return {
                        id: area.UnloadingAreaID,
                        title:
                            area.ShortDescription +
                            ' - ' +
                            area.ContainerDescription,
                        ...area,
                    }
                })

            unloadingAreasColumnHeader = unloadingAreasColumnHeader.sort(
                function (a, b) {
                    let textA = a.title.toUpperCase()
                    let textB = b.title.toUpperCase()
                    return textA < textB ? -1 : textA > textB ? 1 : 0
                }
            )

            // unloadingAreasColumnHeader.push(passObj)
            let containersWithDataArr = unloadingAreasColumnHeader.filter(
                (x, index, self) =>
                    index ===
                    self.findIndex(
                        (t) => t.ContainerDescription === x.ContainerDescription
                    )
            )
            this.containersWithData = containersWithDataArr.filter(function (
                el
            ) {
                return el.ContainerDescription !== 'PASS'
            })
            this.containerSearchFilter = this.containersWithData

            // Show all unloading areas for selected containers (NEW REQUIREMENT)
            this.selectedContainers.forEach((container) => {
                this.allUnloadingAreas.forEach((area) => {
                    if (container.ContainerID === area.ContainerID) {
                        area.ContainerDescription = container.Description
                        unloadingAreasColumnHeader3.push(area)
                    }
                })
            })

            unloadingAreasColumnHeader3 = unloadingAreasColumnHeader3
                .filter((area) => area.IsActive)
                .map((area) => {
                    return {
                        id: area.UnloadingAreaID,
                        title:
                            area.ShortDescription +
                            ' - ' +
                            area.ContainerDescription,
                        ...area,
                    }
                })

            // unloadingAreasColumnHeader3.push(passObj)
            unloadingAreasColumnHeader3 = unloadingAreasColumnHeader3.filter(
                (x, index, self) =>
                    index ===
                    self.findIndex(
                        (t) => t.ShortDescription === x.ShortDescription
                    )
            )
            // Sort unloading area list alphabetically
            unloadingAreasColumnHeader3 = unloadingAreasColumnHeader3.sort(
                function (a, b) {
                    let textA = a.title.toUpperCase()
                    let textB = b.title.toUpperCase()
                    return textA < textB ? -1 : textA > textB ? 1 : 0
                }
            )
            this.allUnloadingAreasOfSelectedContainers = unloadingAreasColumnHeader3

            this.unloadingAreasWithData = unloadingAreasColumnHeader.filter(
                (x, index, self) =>
                    index ===
                    self.findIndex(
                        (t) => t.ShortDescription === x.ShortDescription
                    )
            )
            this.unloadingAreasSearchFilter = this.unloadingAreasWithData
            this.columnHeadersSelectedUnloadedAreas = unloadingAreasColumnHeader

            unloadingAreasColumnHeader2 = unloadingAreasColumnHeader2
                .filter((area) => area.IsActive)
                .map((area) => {
                    return {
                        id: area.UnloadingAreaID,
                        title:
                            area.ShortDescription +
                            ' - ' +
                            area.ContainerDescription,
                        ...area,
                    }
                })

            unloadingAreasColumnHeader2 = unloadingAreasColumnHeader2.sort(
                function (a, b) {
                    let textA = a.title.toUpperCase()
                    let textB = b.title.toUpperCase()
                    return textA < textB ? -1 : textA > textB ? 1 : 0
                }
            )

            // unloadingAreasColumnHeader2.push(passObj)
            this.columnHeadersAllUnloadedAreas = unloadingAreasColumnHeader2

            if (this.showAllUnloadingAreas === 'SHOW_ALL') {
                this.columnHeaders = this.columnHeadersAllUnloadedAreas
            } else if (this.showAllUnloadingAreas === 'SHOW_WITH_DATA') {
                this.columnHeaders = this.columnHeadersSelectedUnloadedAreas
            } else if (this.showAllUnloadingAreas === 'SHOW_WITH_OUT_DATA') {
                this.columnHeaders = _.differenceBy(
                    this.columnHeadersAllUnloadedAreas,
                    this.columnHeadersSelectedUnloadedAreas,
                    'id'
                )
            }
            this.unloadingAreasSearchFilter = this.columnHeaders
            this.originalColumnHeaderArr = this.columnHeaders
            if (this.showPassBookings) {
                this.checkPassBookings(this.showPassBookings)
            }
            this.$refs.calendar.fireMethod('refetchResources')
        },

        async fetchMaterials() {
            let container = this.selectedContainer

            if (!_.isEmpty(container)) {
                let { data } = await this.$http.get(
                    `/BLC/${container.ContainerID}/Notification/MultiStatus?includeStatus=ARRIVED_BLC,PARTIALLY_ALLOCATED_TO_ACTOR,DELIVERY_PARTIALLY_CONFIRMED`
                )
                this.dataMaterials = data
            }
        },

        async fetchDrivers() {
            let container = this.selectedContainer

            if (!_.isEmpty(container)) {
                let { data } = await this.$http.get(
                    `/Container/${container.ContainerID}/User`
                )

                this.driversData = data
            }
        },

        async fetchVehicles() {
            let container = this.selectedContainer

            if (!_.isEmpty(container)) {
                let { data } = await this.$http.get(
                    `/Container/${container.ContainerID}/Vehicle`
                )

                this.vehiclesData = data
            }
        },

        async collectUnloadingAreas() {},

        async fetchUnloadingAreas() {
            let responses = await Promise.all(
                this.selectedContainers.map((container) => {
                    return this.fetchUnloadingArea(container)
                })
            )

            return responses
                .map((response) => {
                    return response.data
                })
                .reduce((a, b) => a.concat(b), [])
        },

        async fetchUnloadingArea(container) {
            let response = await this.$http.get(
                `Container/${container.ContainerID}/UnloadingArea`
            )
            let data = response.data.map((item) => {
                return {
                    ...item,
                    container,
                }
            })
            response.data = data

            return response
        },

        async fetchAllContainers() {
            let { data } = await this.$http.get('Container')
            this.containers = data
            this.checkNodesRecursively(
                data,
                [this.selectedContainer],
                [this.selectedContainer]
            )
        },

        async fetchAllUnloadingAreas() {
            let { data } = await this.$http.get(`UnloadingArea`)
            this.allUnloadingAreas = data
        },

        async updateSchedule(schedule) {
            let fromTime = DateTime.fromISO(
                schedule.start.toISOString()
            ).toFormat(this.dateTimeFormat)
            let toTime = DateTime.fromISO(schedule.end.toISOString()).toFormat(
                this.dateTimeFormat
            )

            await this.$http.put(
                `Actor/${schedule.actorId}/AccessSet/${schedule.accessSetId}/Schedule/${schedule.scheduleId}/SchedulePart/${schedule.id}`,
                {
                    Direction: schedule.direction,
                    IsSimpleSchedule: schedule.isSimpleSchedule,
                    ValidFrom: fromTime,
                    ValidTo: toTime,
                }
            )
        },

        fetchRecipients(container) {
            return this.$http.get(`Container/${container.ContainerID}/User`)
        },

        fetchCheckPoints(container) {
            return this.$http.get(
                `Container/${container.ContainerID}/Checkpoint`
            )
        },

        fetchVehicle(id) {
            return this.$http.get(`Vehicle/${id}`)
        },

        closeDialog() {
            this.dialog = false
            this.editing = false

            this.resetForm()
            this.fetchRoutes()
            this.fetchMaterials()
        },

        resetForm() {
            this.actor = {
                ActorID: '',
            }
            this.gatesData = []
            this.recipientData = []
            this.packageGroups = []
            this.originalPackageGroups = []
            this.form.route = ''
            this.form.pinCode = ''
            this.form.PlateNo = ''
            this.form.vehicle = ''
            this.form.recipient = ''
            this.form.unloadingArea = ''
            this.form.recipientPhone = ''
            this.form.recipientCompany = ''
            this.form.requestedResources = []
        },

        prevDate() {
            this.date = DateTime.fromISO(this.date.toISOString())
                .minus({ days: 1 })
                .toJSDate()
        },

        nextDate() {
            this.date = DateTime.fromISO(this.date.toISOString())
                .plus({ days: 1 })
                .toJSDate()
        },

        today() {
            this.date = DateTime.local().toJSDate()
        },

        tomorrow() {
            this.date = DateTime.local().plus({ days: 1 }).toJSDate()
        },

        async handleBeforeClearAll() {
            try {
                await this.$confirm(
                    'Are you sure you want clear the fields?',
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                return true
            } catch (e) {
                return false
            }
        },

        openMaterialDialog(material) {
            if (
                this.selectedContainer.ContainerID &&
                material &&
                material.BLCNotificationID
            ) {
                this.materialManagerListComponent = 'stc-material-manager-list'
                this.materialDialog = true
                this.blcNotification = {
                    containerID: this.selectedContainer.ContainerID,
                    bLCNotificationID: material.BLCNotificationID,
                }
            }
        },

        closeMaterialDialog() {
            this.materialManagerListComponent = ''
            this.materialDialog = false
            this.blcNotification = undefined
            this.fetchMaterials()
        },

        openFilterMenu() {
            setTimeout(() => {
                this.searchCriteriaOpenState = !this.searchCriteriaOpenState
            }, 100)
        },
    },
}
</script>
<style>
.cross-style {
    right: 10px !important;
}
</style>
<style scoped>
.Status_Success {
    background: #236b6660;
}

.Status_Partial {
    background: #f9a82560;
}
.Light_Blue_Color1 {
    color: #90caf9 !important;
}
.vue-treeselect--disabled .vue-treeselect__multi-value-item {
    background: #e1f5fe !important;
    border: 1px solid transparent !important;
    color: #039be5 !important;
}
.filter-search-btn-color {
    background-color: #38a096 !important;
}

.filter-search-btn-color2 {
    background-color: #f9a825 !important;
}
.vue-treeselect__menu {
    font-size: 14px !important;
}
.vue-treeselect__control {
    font-size: 14px !important;
}
#calendar /deep/ .fc-view-container {
    width: auto !important;
}

#calendar /deep/ .fc-view-container .fc-view {
    overflow-x: scroll !important;
}

#calendar /deep/ .fc-view-container .fc-view > table {
    width: auto !important;
}

#calendar /deep/ .fc-view-container .fc-resource-cell {
    width: 150px !important;
}
#calendar /deep/ .fc-view-container .fc-day {
    width: 160px !important;
}
#calendar /deep/ .fc-view-container .fc-widget-header {
    background: #6b7990 !important;
}
#calendar /deep/ .fc-time-grid-event {
    left: 15% !important;
}
</style>
